import { type PropsWithChildren } from 'react'

import { attach } from 'effector'
import { createGate, useGate } from 'effector-react'
import {
  type NavigateFunction,
  type NavigateOptions,
  type To,
  useNavigate,
} from 'react-router-dom'

const RouterEffectsGate = createGate<{
  navigate: NavigateFunction
}>()
export function RouterEffectsProvider({ children }: PropsWithChildren) {
  const navigate = useNavigate()
  useGate(RouterEffectsGate, {
    navigate,
  })
  return children
}

export const navigateToFx = attach({
  source: RouterEffectsGate.state,
  effect(
    { navigate },
    {
      to,
      options,
    }: {
      to: To
      options?: NavigateOptions
    },
  ) {
    return navigate(to, options)
  },
})
